import { createSelector } from '@reduxjs/toolkit';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getThreadsAsyncData } from './getThreadsAsyncData';
export const getThreads = createSelector([getThreadsAsyncData], threads => getData(threads));